import Vue from 'ninenine-white-label/Vue'
import Vuex from 'vuex'

import opportunities from 'ninenine-white-label/store/modules/opportunities'
import location from 'ninenine-white-label/store/modules/location'
import user from 'ninenine-white-label/store/modules/user'
import domains from 'ninenine-white-label/store/modules/domains'
import graphql_queries from 'ninenine-white-label/store/modules/graphql_queries'
import tests from 'ninenine-white-label/store/modules/tests'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    opportunities,
    location,
    user,
    domains,
    graphql_queries,
    tests
  },

  state: {
    source: 'carreiras',
    companyId: process.env.VUE_APP_COMPANY_ID,
    tkn: `Token token=${process.env.VUE_APP_API_TOKEN}`,
    deviseForm: null,
    deviseLoading: false,
    deviseTrying: {},
    personalDataForm: {},
    educationsForms: [],
    professionalExperiencesForms: [],
    languagesForms: [],
    flag_no_professional_experience: false,
    opportunityQuestionsForm: {},
    indicationForm: {},

    levels: [{
        "id": 1,
        "name": "Jovem Aprendiz"
      },
      {
        "id": 3,
        "name": "Estágio"
      },
      {
        "id": 4,
        "name": "Trainee"
      },
      {
        "id": 8,
        "name": "Assistente"
      },
      {
        "id": 10,
        "name": "Júnior"
      },
      {
        "id": 11,
        "name": "Pleno"
      },
      {
        "id": 12,
        "name": "Sênior"
      },
      {
        "id": 13,
        "name": "Coordenador"
      },
      {
        "id": 14,
        "name": "Especialista"
      },
      {
        "id": 15,
        "name": "Gerente"
      },
      {
        "id": 17,
        "name": "Diretor"
      }
    ],

    teams: [
      {
        "title": "Fábrica",
        "slug": "fabrica",
        "coverImage": "banner-fabrica-cover.jpeg"
      },
      {
        "title": "Escritório",
        "slug": "escritorio",
        "coverImage": "banner-escritorio-cover.jpeg"
      },
      {
        "title": "Loja",
        "slug": "loja",
        "coverImage": "banner-loja-cover.jpeg"
      },
      {
        "title": "Centro de Distribuição",
        "slug": "cd",
        "coverImage": "banner-cd-cover.jpeg"
      },
    ],

    areas: [
      { id: "3635", name: "Bobstore", },
      { id: "3632", name: "Ellus", },
      { id: "3746", name: "Ellus 2nd Floor", },
      { id: "3633", name: "Richards", },
      { id: "3634", name: "Salinas", },
      { id: "3637", name: "Tommy Hilfiger", },
      { id: "3744", name: "VR Collezioni", },
    ],

    faqItems: [{
        title: ``,
        content: ``
      },
    ],

  },

  getters: {
    basicProfileEmpty: state => {
      const profile = state.user.profile || {};

      return (
          !profile.nationality || profile.nationality.length == 0 ||
          (
            (!profile.cpf || profile.cpf.length == 0) &&
            (!profile.passport || profile.passport.length == 0)
          ) ||
          !profile.phone || profile.phone.length == 0 ||
          !profile.birthday || profile.birthday.length == 0 ||
          !profile.gender || profile.gender.length == 0 ||
          !profile.raceAndEthnicity || profile.raceAndEthnicity.length == 0 ||
          !profile.pronoun || profile.pronoun.length == 0 ||
          !profile.personalIncome || profile.personalIncome.length == 0 ||
          !profile.familyIncome || profile.familyIncome.length == 0 ||
          !profile.location.zipcode || profile.location.zipcode.length == 0 ||
          !profile.location.street || profile.location.street.length == 0 ||
          !profile.location.number || profile.location.number.length == 0 ||
          !profile.location.neighborhood || profile.location.neighborhood.length == 0 ||
          !profile.location.city || profile.location.city.length == 0 ||
          !profile.location.stateId || profile.location.stateId.toString().length == 0
        ) &&
        (!profile.educations || profile.educations.length == 0) &&
        (!profile.professionalExperiences || profile.professionalExperiences.length == 0 || state.flag_no_professional_experience == false)
    }
  },

  mutations: {
    CHANGE_TKN(state, payload) {},

    DEVISE_FORM(state, payload) {
      state.deviseForm = payload;
    },

    DEVISE_LOADING(state, payload) {
      state.deviseLoading = payload;
    },

    DEVISE_TRYING(state, payload) {
      state.deviseTrying = payload == null ? {} : payload;
    },

    PERSONAL_DATA_FORM(state, payload) {
      state.personalDataForm = payload;
    },

    EDUCATIONS_FORMS(state, payload) {
      if (!payload) {
        state.educationsForms = []
      } else {
        if (state.educationsForms.find(form => form._uid == payload._uid)) {
          state.educationsForms[state.educationsForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.educationsForms.push(payload);
        }
      }
    },

    PROFESSIONAL_EXPERIENCES_FORMS(state, payload) {
      if (!payload) {
        state.professionalExperiencesForms = []
      } else {
        if (state.professionalExperiencesForms.find(form => form._uid == payload._uid)) {
          state.professionalExperiencesForms[state.professionalExperiencesForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.professionalExperiencesForms.push(payload);
        }
      }
    },

    LANGUAGES_FORMS(state, payload) {
      if (!payload) {
        state.languagesForms = []
      } else {
        if (state.languagesForms.find(form => form._uid == payload._uid)) {
          state.languagesForms[state.languagesForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.languagesForms.push(payload);
        }
      }
    },

    SET_FLAG_PROFESSIONAL_EXPERIENCE(state, payload) {
      state.flag_no_professional_experience = payload
    },

    OPPORTUNITY_QUESTIONS_FORM(state, payload) {
      state.opportunityQuestionsForm = payload
      localStorage.setItem('opportunity_questions', JSON.stringify(payload))
    },

    INDICATION_FORM(state, payload) {
      state.indicationForm = payload
      localStorage.setItem('indication_form', JSON.stringify(payload))
    }
  }

});